import { Observable } from 'rxjs';

import { MultiFormSelectOptions } from '../../../form-controls/entities/multi-form-select-options.entity';
import { AutocompleteFunction } from '../../common/entities/autocompleteFunction.entity';
import { ShAutocompleteService } from '../services/autocomplete.service';

export function getAutocompleteFctHelper(
    fieldDefinitionDottedKey: string,
    autocompleteService: ShAutocompleteService,
    translateValues: boolean = true
): AutocompleteFunction {
    // named function to provide autocomplete to multiselect form components
    return function getFieldAutocomplete(query: string): Observable<MultiFormSelectOptions> {
        return autocompleteService.getFieldAutocomplete(fieldDefinitionDottedKey, query, translateValues);
    };
}
